<template>
  <div class="full-width">
    <AppEditForm
      padding
      class="row q-px-md q-mb-xl"
      @save="save"
      :edit="edit"
      :new="isNew"
    >
      <div class="gt-xl col-xl-2" />
      <div class="col-12 col-sm-9 col-xl-6 q-mt-md row">

        <div class="col-12 q-px-sm">
          <AppInput v-if="!isNew"
              label="GR"
              v-model="tema.numero"
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppInput label="Questão Jurídica *" v-model="tema.descricao" autogrow type="textarea"
           editable
           required
           maxlength="1000"
           showCounter
          />
        </div>
        <div class="col-12 q-px-sm">
          <AppInput
              label="Anotações NUGEPNAC"
              autogrow
              type="textarea"
              v-model="tema.anotacoesNugep"
              v-if="tema.anotacoesNugep || edit || userStore.admin"
              editable
          />
        </div>
        <div class="col-12 q-px-sm">
          <AppInput
              label="Alcance do Sobrestamento"
              autogrow
              type="textarea"
              v-model="tema.alcanceSobrestamento"
              v-if="tema.alcanceSobrestamento || edit || userStore.admin"
              editable
          />
        </div>
        <div class="col-12  q-px-sm" v-if="tema.numeroTemaVinculado || edit || userStore.admin">
          <AppInput label="Número Tema Vinculado" v-model="tema.numeroTemaVinculado"
          editable
          mask="####"
          />
        </div>
        <div class="col-8  q-px-sm">
          <AppSelect
              label="Situação *"
              v-model="situacao"
              @filter="situacaoFilter"
              :options="situacoes"
              editable
          />
        </div>
        <div class="col-sm-4 col-12  q-px-sm">
          <AppDateSelect label="Data da Situação *" v-model="tema.dataSituacaoGrupoRepresentativo" editable required/>
        </div>
        <div class="col-12 q-px-sm text-right">
          <q-chip v-if="tema.statusEnvioBnp && userStore.admin" outline square color="green" text-color="white" icon="done">
            Enviado ao BNP
          </q-chip>
          <q-chip v-if="!tema.statusEnvioBnp && userStore.admin" outline square color="red" text-color="white" icon="close">
            Não enviado ao BNP
          </q-chip>
          <q-chip v-if="tema.statusEnvioPje && userStore.admin" outline square color="green" text-color="white" icon="done">
            Enviado ao PJE
          </q-chip>
          <q-chip v-if="!tema.statusEnvioPje && userStore.admin" outline square color="red" text-color="white" icon="close">
            Não enviado ao PJE
          </q-chip>
        </div>
      </div>
      <AppTimeline
        class="col-12 col-sm-3 col-xl-2"
        v-model="timeline"
        :edit="edit || isNew"
        :requires=0
      />

      <div class="gt-xl col-xl-2" />
      <div class="gt-xl col-xl-2" />
      <div class="col-xl-8 col-sm-12">
        <AppInfiniteListForm v-model="processosparadigma">
          <template v-slot:item="data">
            <MiniProcessoParadigma v-bind="data" />
          </template>
        </AppInfiniteListForm>
      </div>

      <div class="gt-xl col-xl-2" />
      <q-page-sticky
        position="bottom-right"
        :offset="[18, 18]"
        v-if="userStore.admin"
      >
        <AppSaveBtn v-if="edit" :disable="disableButton"/>
        <AppDeleteBtn v-if="!isNew" @click="showConfirmDeletion" :disable="disableButton"/>
        <AppEditBtn v-if="!isNew" @click="toggleEditMode" />
      </q-page-sticky>
    </AppEditForm>
    <TjpaDemandasDeleteModal
      :show="showConfirmDeletionModal"
      @update:show="showConfirmDeletionModal = $event"
      @confirmDeletion="confirmDeletion"
      :id="$route.params.id"
    />
  </div>
</template>


<script setup>
import MiniProcessoParadigma from "@/components/gr/GrMiniProcessoPje.vue";
MiniProcessoParadigma;
import AppInfiniteListForm from "@/components/gr/AppInfiniteListFormGr.vue";
AppInfiniteListForm;
import AppEditForm from "../app/AppEditForm.vue";
import AppDeleteBtn from "../app/AppDeleteBtn.vue";
import AppEditBtn from "../app/AppEditBtn.vue";
import AppSaveBtn from "../app/AppSaveBtn.vue";
import AppInput from "../app/AppInput.vue";
import AppSelect from "../app/AppSelect.vue";
import AppTimeline from "@/components/app/AppTimeline.vue";
AppTimeline;
import TjpaDemandasDeleteModal from "../tjpa-demandas-delete-modal.vue";

import { useProcessoParadigmaStore } from "@/store/processoparadigma-store";
import { useGrSituacaoStore } from "@/store/gr-situacao-store";

import { useGRStore } from "@/store/gr-store";
import { useUserStore } from "@/store/user-store";

import { ref, computed, defineProps } from "vue";
import { useQuasar } from "quasar";
import { useRouter, useRoute } from "vue-router";

const quasar = useQuasar();
const router = useRouter();
const route = useRoute();

const userStore = useUserStore();
const situacaoStore = useGrSituacaoStore();
situacaoStore.fetch();

const notify = (...p) => quasar.notify(...p);

const temaStore = useGRStore();

import {
  filterFunction,
  baseUrlDelete,
  DELETE_FAILURE,
  DELETE_SUCCESS, CREATE_SUCCESS, ALTER_SUCCESS
} from "@/DemandasRepetitivas";
import AppDateSelect from "@/components/app/AppDateSelect.vue";

const procStore = useProcessoParadigmaStore();

const props = defineProps({ id: { type: String } });
props.id && temaStore.fetchStg(props.id);

const _edit = ref(false);

const tema = computed(() => temaStore.stgTema);

const processosparadigma = computed({
  get: () => edit.value ? procStore.processos: tema.value.processosParadigma,
  set: v => (procStore.processos = v)
});

const sourceTema = computed(
  () => props.id && temaStore.all.find(t => t.id == props.id)
);

const isNew = computed(() => !props.id);
const showConfirmDeletionModal = ref(false);
const disableButton = ref(false);


const admin = computed(() => userStore.admin)
const situacoes = computed(() => situacaoStore.filtered);

const situacao = computed({
  get: () => (situacaoStore.all?.find(s => s.id == tema.value.idSituacao)),
  set: v => (tema.value.idSituacao = v.id)
});

const edit = computed({get:() => (_edit.value && admin.value),set:v=>(_edit.value = v)})

const toggleEditMode = () => {
  edit.value = !edit.value ;
  if(edit.value == true){
    procStore.processos = tema.value.processosParadigma;
  }
  if (edit.value == false && tema.value.equals(sourceTema.value) == false) {
    notify({
      message: "Existem Alterações não salvas",
      color: "warning"
    });
  }
};

if (isNew.value) {
  temaStore.clearStg();
  procStore.clear();

  edit.value = false;
  toggleEditMode();
}

const timeline = computed({
  get: () => {
    const { dataCriacao} = tema.value;
    return [
      { order: 0, name: "Criação *", date: dataCriacao, icon: "add" }
    ];
  },
  set: v => {
    let timelineFields = ["Criacao"];
    timelineFields = timelineFields.map(
        fieldName => (fieldName = `data${fieldName}`)
    );
    timelineFields.forEach(
        (fieldName, i) => (tema.value[fieldName] = v[i].date)
    );
  }
});
const situacaoFilter = (val, update) =>
  filterFunction(...[situacoes.value, situacaoStore.all, val, update]);

const save = async () => {

  if (!situacao.value) {
    notify({
      message: "É obrigatória a escolha de uma situação.",
      color: "warning"
    });
    return;
  }

  disableButton.value = true;

  let success_msg = isNew.value ? CREATE_SUCCESS : ALTER_SUCCESS;

  const reload = () => temaStore.clearStg();
  const failure = msg =>
      notify({
        message: msg,
        color: "negative"
      });
  const success = (id) =>
    notify({
      message: `O grupo representativo ${id} ` + success_msg,
      color: "positive"
    });

  const successAndReload = id => {
    success(id);
    router.push("/grhome");
    if(isNew.value){
      reload();
    }
  };
  try {
    const readResponse = await temaStore.saveStg();
    successAndReload(readResponse.data);
    //failure(id);
  } catch (e) {
    disableButton.value = false;
    if(e.response.status == 401){
      failure("Sessão Expirou.");
      router.push("/grhome");
      reload();
    }else{
      failure(e.response.data.message);
    }
  }
};

const goHome = () => router.push("/");

const showConfirmDeletion = () => (showConfirmDeletionModal.value = true);
const confirmDeletion = () => {
  disableButton.value = true;
  const reload = () => goHome();

  const notifyObj = (message, color) => ({ message, color });
  const failure = () => notify(notifyObj(DELETE_FAILURE, "negative"));
  const success = () => notify(notifyObj(DELETE_SUCCESS, "positive"));

  const successAndReload = () => {
    success();
    reload();
  };
  const httpOk = r => r.status == 200;
  const readResponse = r => (httpOk(r) ? successAndReload() : failure());

  baseUrlDelete(`gruporepresentativo/${route.params.id}`)
    .then(readResponse)
    .catch(failure);
};
</script>

<style lang="scss" >
@import "@/styles/quasar.variables.sass";

.tjpa-select-input {
  max-height: 30vh !important;
}

.AppSelect__dialog {
  margin-top: 90px;
}
</style>
